import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import React from 'react';
import { IconIdentificationCard, IconPassport} from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import {FILE_TYPE_MODEL} from '../Visitor/Model/Model';
import ChooseType from './Components/ChooseType';
import ChooseValidationTypeApp from './Functionality/ChooseValidationTypeApp';
import useForbiddenValidation from './Functionality/useForbiddenValidation';
import {getUrlParameters} from "./Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ChooseValidationType = () => {
    const { t, id, guardFlowId, selectionType, setSelectionType, getUrl, getInvitationById } = ChooseValidationTypeApp();
    useForbiddenValidation({getInvitationById});

    return (
        <ContainerValidation>
            <HeaderValidation url={getUrlParameters({ url: routes.invitationDetails.identityValidation, id, guardFlowId })}/>

            <BodyValidation
                click={() => { getUrl() }}
                btnDisabled={selectionType == ''}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">
                                { t(guardFlowId ? "please_choose_one_of_following_documents_to_proceed_with_validation": "please_choose_validation_type")}
                            </p>
                        </div>
                    </div>

                    <ChooseType
                        id="rbtn_cvt_select_passport"
                        title="passport"
                        subtitle="take_a_photo_of_the_passport_photo_page"
                        Icon={IconPassport}
                        name={FILE_TYPE_MODEL.PASSPORT.id}
                        value={FILE_TYPE_MODEL.PASSPORT.id}
                        checked={selectionType == FILE_TYPE_MODEL.PASSPORT.id}
                        setSelectionType={setSelectionType}
                    />

                    <ChooseType
                        id="rbtn_cvt_select_id_card"
                        title="id_card"
                        subtitle={guardFlowId? "take_photos_of_both_sides_of_the_id_card" : "take_photos_of_both_sides_of_your_id_card"}
                        Icon={IconIdentificationCard}
                        name={FILE_TYPE_MODEL.INE.id}
                        value={FILE_TYPE_MODEL.INE.id}
                        checked={selectionType == FILE_TYPE_MODEL.INE.id}
                        setSelectionType={setSelectionType}
                    />
                </>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default ChooseValidationType
